var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitoring = function SvgMonitoring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "monitoring_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 21v-2l2-2v4zm4 0v-6l2-2v8zm4 0v-8l2 2.025V21zm4 0v-5.975l2-2V21zm4 0V11l2-2v12zM3 15.825V13l7-7 4 4 7-7v2.825l-7 7-4-4z"
  })));
};
export { SvgMonitoring as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMyAyMVYxOUw1IDE3VjIxSDNaTTcgMjFWMTVMOSAxM1YyMUg3Wk0xMSAyMVYxM0wxMyAxNS4wMjVWMjFIMTFaTTE1IDIxVjE1LjAyNUwxNyAxMy4wMjVWMjFIMTVaTTE5IDIxVjExTDIxIDlWMjFIMTlaTTMgMTUuODI1VjEzTDEwIDZMMTQgMTBMMjEgM1Y1LjgyNTAxTDE0IDEyLjgyNUwxMCA4LjgyNTAxTDMgMTUuODI1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";